module.exports = __webpack_public_path__ + "static/media/19ingreso.19e8733.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/19ingreso.mp4
// module id = 724
// module chunks = 1